import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { closest, getTransformProps, getOffsetRect, getTotalScroll } from '@elliemae/ds-shared/utils';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function onDragStart(e, item) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  this.el = closest(e.target, '.nestable-item');
  this.startTrackMouse();
  this.onMouseMove(e);
  var items = this.state.items;
  this.setState({
    dragItem: item,
    itemsOld: items
  });
}
function onDragEnd(e, isCancel) {
  if (e && e.preventDefault) e.preventDefault();
  this.stopTrackMouse();
  this.el = null; // check if filter has children

  var items = this.state.items;
  var nestedInFilter = this.checkFilterChildren(items);
  if (nestedInFilter) return this.dragRevert();
  return isCancel ? this.dragRevert() : this.dragApply();
}
function onMouseMove(e) {
  var _this$props = this.props,
      group = _this$props.group,
      threshold = _this$props.threshold;
  var dragItem = this.state.dragItem;
  var clientX = e.clientX,
      clientY = e.clientY;
  var transformProps = getTransformProps(clientX, clientY);
  var elCopy = document.querySelector(".nestable-".concat(group, " .nestable-drag-layer > .nestable-list"));

  if (!this.elCopyStyles) {
    var offset = getOffsetRect(this.el);
    var scroll = getTotalScroll(this.el);
    this.elCopyStyles = _objectSpread({
      marginTop: offset.top - clientY - scroll.top,
      marginLeft: offset.left - clientX - scroll.left
    }, transformProps);
  } else {
    this.elCopyStyles = _objectSpread(_objectSpread({}, this.elCopyStyles), transformProps);

    for (var key in transformProps) {
      if (transformProps.hasOwnProperty(key)) {
        elCopy.style[key] = transformProps[key];
      }
    }

    var diffX = clientX - this.mouse.last.x;

    if (diffX >= 0 && this.mouse.shift.x >= 0 || diffX <= 0 && this.mouse.shift.x <= 0) {
      this.mouse.shift.x += diffX;
    } else {
      this.mouse.shift.x = 0;
    }

    this.mouse.last.x = clientX;

    if (Math.abs(this.mouse.shift.x) > threshold) {
      if (this.mouse.shift.x > 0) {
        this.tryIncreaseDepth(dragItem);
      } else {
        this.tryDecreaseDepth(dragItem);
      }

      this.mouse.shift.x = 0;
    }
  }
}
function onMouseEnter(e, item) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  var _this$props2 = this.props,
      collapsed = _this$props2.collapsed,
      childrenProp = _this$props2.childrenProp;
  var dragItem = this.state.dragItem;
  if (dragItem.id === item.id) return;
  var pathFrom = this.getPathById(dragItem.id);
  var pathTo = this.getPathById(item.id); // if collapsed by default
  // and move last (by count) child
  // remove parent node from list of open nodes

  var collapseProps = {};

  if (collapsed && pathFrom.length > 1) {
    var parent = this.getItemByPath(pathFrom.slice(0, -1));

    if (parent[childrenProp].length === 1) {
      collapseProps = this.onToggleCollapse(parent, true);
    }
  }

  this.moveItem({
    dragItem: dragItem,
    pathFrom: pathFrom,
    pathTo: pathTo
  }, collapseProps);
}
function onToggleCollapse(item, isGetter) {
  var collapsed = this.props.collapsed;
  var collapsedGroups = this.state.collapsedGroups;
  var isCollapsed = this.isCollapsed(item);
  var newState = {
    collapsedGroups: isCollapsed ^ collapsed ? collapsedGroups.filter(function (id) {
      return id !== item.id;
    }) : collapsedGroups.concat(item.id)
  };

  if (isGetter) {
    return newState;
  }

  return this.setState(newState);
}
function onKeyDown(e) {
  if (e.which === 27) {
    // ESC
    this.onDragEnd(null, true);
  }
}

export { onDragEnd, onDragStart, onKeyDown, onMouseEnter, onMouseMove, onToggleCollapse };
//# sourceMappingURL=events.js.map
